/**------------- Cookie Button constants -------------**/

/*  General  */
export const COOKIE_BUTTON_CLASS_NAME = "cookie-button";
export const COOKIE_BUTTON_ARIA_LABEL = "Gestisci cookies";
